import styled from 'styled-components';
import { Theme } from '@mui/material/styles';

const Separator = styled.hr<{ theme: Theme }>`
  border-color: ${({ theme }) => theme.palette.grey['100']};
  color: ${({ theme }) => theme.palette.error.main};
  width: 100%;
`;

export { Separator };
